import { AuthActionType } from './auth-action-type';

export interface ChangePasswordRequestAction {
  token?: string;
  currentPassword?: string;
  newPassword?: string;
  type: AuthActionType.ChangePasswordRequest;
}

export const changePasswordRequest = (
  input: Pick<
    ChangePasswordRequestAction,
    'token' | 'currentPassword' | 'newPassword'
  >,
): ChangePasswordRequestAction => ({
  ...input,
  type: AuthActionType.ChangePasswordRequest,
});
